<template>
  <v-row align="start" justify="center" class="ma-0 px-8" :style="roomStyle">
    <div class="room-bg room-bg-top-left" :style="{backgroundImage: Room ? `url(${optimizedImageURL(Room.topLeftBackgroundImage)}` : null}" />
    <div class="room-bg room-bg-bottom-right" :style="{backgroundImage: Room ? `url(${optimizedImageURL(Room.bottomRightBackgroundImage)}` : null}" />
    <v-col cols="12" style="position: relative;">
      <v-row align="center" justify="center" class="ma-0">
        <v-btn fab large light depressed class="py-8" exact :to="{name: 'Home'}" :style="{color: Room ? Room.secondaryTextColor : null, backgroundColor: Room ? Room.secondaryBackgroundColor : null}"><v-icon x-large>mdi-close</v-icon></v-btn>
      </v-row>
    </v-col>
    <transition mode="out-in">
      <v-col cols="auto" :style="{width: '100%', maxWidth: '120vh'}" v-if="Room" key="loaded">
        <v-responsive :aspect-ratio="16/9" style="background-color: #000;">
          <v-row no-gutters class="fill-height" align="center" justify="center" v-if="!hasValidSpentTicket" style="background-color: #0091d7;">
            <mail-ticket-form class="col col-11 col-md-8" />
          </v-row>
        </v-responsive>
      </v-col>
      <v-col cols="auto" v-else key="loading">
        <v-progress-circular indeterminate  />
      </v-col>
    </transition>
  </v-row>
</template>
<script>
import getVideoId from 'get-video-id'
import GetRoom from '@/graphql/GetRoom.gql'
import { Viewport } from '@monogrid/vue-lib'
import { optimizedImageURL } from '@/services/OptimizedImage'
import MailTicketForm from '@/organisms/MailTicketForm.vue'
import findIndex from 'lodash/findIndex'
import { userHasRequestedACL, EDITOR_ACL } from '@/services/AuthLevel'

export default {
  name: 'LiveStreamPage',
  mixins: [Viewport],
  components: {
    MailTicketForm
  },
  props: {
    slug: {
      type: String,
      required: true
    }
  },
  methods: {
    getVideoId,
    optimizedImageURL
  },
  computed: {
    hasValidSpentTicket () {
      if (userHasRequestedACL(this.$root.auth.loggedUser, EDITOR_ACL)) {
        return true
      }
      return this.$root.databaseUser &&
        this.$root.databaseUser.spentTickets &&
        Array.isArray(this.$root.databaseUser.spentTickets) &&
        findIndex(this.$root.databaseUser.spentTickets, (t) => t.indexOf('E931') === 0) !== -1
    },
    roomStyle () {
      if (this.Room) {
        return {
          position: 'relative',
          height: `${this.viewPort.height}px`,
          backgroundColor: `${this.Room.primaryBackgroundColor}`
        }
      }
      return {}
    }
  },
  apollo: {
    Room: {
      query: GetRoom,
      variables () {
        return {
          status: 'PUBLISHED',
          slug: this.slug
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.room-bg {
  position: absolute;
  width: 50vh;
  height: 50vh;
  background-size: 100% 100%;
  background-repeat: no-repeat;

  &-top-left {
    top: 20px;
    left: 0;
  }

  &-bottom-right {
    bottom: 0;
    right: 0;
  }
}
</style>
